import { toString } from './_setup.js';
// Is a given value a boolean?
export default function isBoolean(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
}
